import { render, staticRenderFns } from "./industry.vue?vue&type=template&id=6c9a199e"
import script from "./industry.vue?vue&type=script&lang=js"
export * from "./industry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c9a199e')) {
      api.createRecord('6c9a199e', component.options)
    } else {
      api.reload('6c9a199e', component.options)
    }
    module.hot.accept("./industry.vue?vue&type=template&id=6c9a199e", function () {
      api.rerender('6c9a199e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/basic/industry.vue"
export default component.exports